import request from '@/axios'
import { customercateType, customerfastType, listBodyType, listResType } from './types'
import { groupItemType } from '@/types/Customer/Reply'

/** 聊天分组列表 */
export const customercateApi = (data: any): Promise<IResponse<listResType<customercateType>>> => {
  return request.post({ url: '/admin/customercate', data })
}

/** 添加聊天分组 */
export const customercatesaveApi = (data: customercateType): Promise<IResponse<any>> => {
  return request.post({ url: '/admin/customercatesave', data })
}

/** 删除聊天分组 */
export const customercatedelApi = (params: { id: number }): Promise<IResponse<any>> => {
  return request.get({ url: '/admin/customercatedel', params })
}

/** 设置咨询人员分组 */
export const customercateseApi = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/admin/customercateset', data })
}

/******快捷回复******/

/** 快捷回复列表 */
export const customerfastApi = (
  data: listBodyType
): Promise<IResponse<listResType<customerfastType>>> => {
  return request.post({ url: '/admin/customerfast', data })
}

/** 添加快捷回复 */
export const customerfastsaveApi = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/admin/customerfastsave', data })
}

/** 删除快捷回复 */
export const customerfastdeleApi = (params: { id: number }): Promise<IResponse<any>> => {
  return request.get({ url: '/admin/customerfastdel', params })
}

/******翻译接口******/
export const translationSendApi = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/translation/send', data })
}

/*****获取游戏用户信息******/
export const getGameUserInfoApi = (data: {
  user_id: number
}): Promise<IResponse<groupItemType[]>> => {
  return request.post({ url: '/admin/getgameuserinfo', data })
}

/** 设置咨询人员置顶 */
export const customerusertopApi = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/admin/customerusertop', data })
}

/*******撤销发出的消息**********/
export const customermsgdelApi = (params: { uuid: string }): Promise<IResponse<any>> => {
  return request.get({ url: '/admin/customermsgdel', params })
}

/****标记为已解决***/
export const consultationstatusApi = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/admin/consultationstatus', data })
}

/***聊天大厅消息列表****/
export const chatgroupmessageApi = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/admin/chatgroupmessage', data })
}

/******删除某条大厅聊天记录******/
export const chatdelmessageApi = (data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/admin/chatdelmessage', data })
}
